<template lang="html">
    <!--        上传材料模块 -->
    <cc-preview-module title="上传材料" class="fd-preview-sccl-module">
        <ac-preview-file
            title="保全申请书"
            :data="sqsFiles"></ac-preview-file>
        <ac-preview-file v-if="bqlb === '4'"
            title="生效法律文书"
            :data="sxflwsFiles"></ac-preview-file>
        <template v-else>
            <ac-preview-file
                title="起诉书"
                :data="qszFiles"></ac-preview-file>
            <ac-preview-file
                title="立案受理通知书"
                :data="lasltzsFiles"></ac-preview-file>
        </template>
        <!--        子集模块 -->
        <div class="fd-sccl-module-child">
            <!--        身份证明材料-->
            <h5 class="fd-sccl-module-child-tit">身份证明材料</h5>
            <ac-preview-file
                class="fd-sccl-module-child-upload"
                v-for="item in sfzmFiles"
                :key="item.ryid"
                :title="item.rymc"
                :data="item.clList"></ac-preview-file>
        </div>
        <!--        子集模块 -->
        <div class="fd-sccl-module-child" v-if="dbqk === '1'">
            <!--        身份证明材料-->
            <h5 class="fd-sccl-module-child-tit">担保材料</h5>
            <ac-preview-file
                class="fd-sccl-module-child-upload"
                v-for="item in dblFiles"
                :key="item.dblxmc"
                :title="item.dblxmc"
                :data="item.clList"></ac-preview-file>
        </div>
        <ac-preview-file
            title="证据材料"
            :data="zjFiles"></ac-preview-file>
        <ac-preview-file
            title="其他材料"
            :data="qtFiles"></ac-preview-file>
    </cc-preview-module>
</template>

<script>
    // 模块预览组件
    import ccPreviewModule from '@/components/common/preview-module/index.vue';
    // 预览文件
    import acPreviewFile from '@/components/app/preview-file/index.vue';
    import wx from 'weixin-js-sdk'
    import {getToken} from "../../../utils/auth";
    export default {
        components: {
            ccPreviewModule,
            acPreviewFile
        },
        // 注入
        inject: ['bqid', 'bqlb', 'dbqk'],
        data() {
            return {
                sqsFiles: [],//申请书
                sxflwsFiles:[],//生效法律文书
                qszFiles: [],//起诉状
                lasltzsFiles: [],//立案受理通知书
                sfzmFiles: [],//身份证明
                dblFiles: [],//担保类
                zjFiles: [],//证据类
                qtFiles: [],
                bz: "",
            }
        },
        methods: {
              // 下载保单
            downloadFileBD(dbid) {
                wx.miniProgram.navigateTo({
                    url: '/pages/download/download?id='+dbid+'&token='+getToken()
                })
            },
            // 下载保函
            downloadFileBH(dbid) {
                wx.miniProgram.navigateTo({
                    url: '/pages/downloadBh/downloadBh?id='+dbid+'&token='+getToken()
                })
            },
            getCcxsList() {
                this.$axios.get('ssbq/api/sccls/sccls' + "?time=" + new Date().getTime() + "&bqid=" + this.bqid).then(res => {
                    this.sqsFiles = res.data.sqs
                    this.sxflwsFiles=res.data.sxflws;
                    this.qszFiles = res.data.qsz
                    this.lasltzsFiles = res.data.lasltzs
                    this.sfzmFiles = res.data.sfzml
                    this.zjFiles = res.data.zjl
                    this.qtFiles = res.data.qt
                    this.dblFiles = res.data.dbl
                })
            }
        },
        mounted() {
            this.getCcxsList()
        }
    }
</script>

<style lang="less" scoped>
    .fd-files-box {
        width: 100%;
        background: #fff;

        > h5 {
            line-height: 40px;
            margin-left: 16px;
            font-size: 15px;
            font-weight: bold;
        }

        .sfzm-person {
            color: #333;
            line-height: 40px;
        }

        .fd-img-box {
            width: 100px;
            height: 100px;
            margin-left: 16px;
            margin-top: 10px;
            margin-bottom: 10px;

            > img {
                width: 100%;
                height: 100%;
            }

            .fd-sfzm-box {
                width: 100%;
                height: 100%;

                > img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .fd-sfzmImg-box {
            margin-left: 16px;
            margin-bottom: 10px;

            .fd-sfzm-box {
                width: 100px;
                height: 100px;

                > img {
                    width: 100%;
                    height: 100%;
                }
            }

        }

    }
    // 为空的提示
    .fd-empty-tips {
        font-size: 14px;
    }
</style>
